  <!-- 修改承运商档案 -->
  <template>
  <div id="NVOCC_create">
    <div class="NVOCC_title">
      <div
        v-for="(item, index) in options"
        :key="index"
        :class="{ activeItem: currentTab === item.tabModName }"
        @click="itemClick(item.tabModName)"
      >
        <span>{{ item.tabName }}</span>
      </div>
    </div>
    <keep-alive>
      <component
        :is="currentTab"
        :common="commonProp"
        @RELOADPAGE="reloadpage"
      />
    </keep-alive>
  </div>
</template>
  <script >
import baseinfo from "@/pages/Customers/NVOCCMODRX/BaseInfo.vue";
import account from "@/pages/Customers/NVOCCMODRX/account.vue";
import network from "@/pages/Customers/NVOCCMODRX/network.vue";
import contractManagement from "@/pages/Customers/NVOCCMODRX/contractManagement.vue";
import Qualifications from "@/pages/Customers/NVOCCMODRX/Qualifications.vue";
import systemDock from "@/pages/Customers/NVOCCMODRX/systemDock.vue";
// import linedefend from "@/pages/Customers/NVOCCMODRX/line.vue";
export default {
  inject: ["reload"],
  components: {
    baseinfo,
    account,
    network,
    contractManagement,
    Qualifications,
    systemDock,
    // linedefend,
  },
  data() {
    return {
      options: [
        {
          tabName: "基础信息",
          tabModName: "baseinfo",
        },
        {
          tabName: "收款账号",
          tabModName: "account",
        },
        {
          tabName: "网点维护",
          tabModName: "network",
        },
        {
          tabName: "合同管理",
          tabModName: "contractManagement",
        },
        {
          tabName: "资质信息",
          tabModName: "Qualifications",
        },
        {
          tabName: "系统对接",
          tabModName: "systemDock",
        },
        // {
        //   tabName: "线路维护",
        //   tabModName: "linedefend",
        // },
      ],
      currentTab: "baseinfo",
      commonProp: {
        carrierNumber: null,
        carrierId: null,
        carrierName: null,
        CollectionArr: new Array(),
      },
    };
  },
  created() {
    this.commonProp.carrierNumber = this.$route.query.carrierNumber;
    this.commonProp.carrierId = this.$route.query.carrierId;
    this.commonProp.carrierName = this.$route.query.carrierName;
  },
  watch: {
    $route(to, from) {
      let id = this.$route.query.carrierId || "";
      if (id) {
        this.commonProp.carrierNumber = this.$route.query.carrierNumber;
        this.commonProp.carrierId = this.$route.query.carrierId;
        this.commonProp.carrierName = this.$route.query.carrierName;
      }
    },
  },

  methods: {
    itemClick(tab) {
      this.currentTab = tab;
    },
    reloadpage() {
      this.$TOOLS.closePage();
      this.$router.push({
        path: "/Customers/NVOCC",
        query: {
          isreload: "isreload",
        },
      });
    },
  },
};
</script>
  <style scoped lang="less">
.NVOCC_title {
  background: rgba(0, 0, 0, 0.08);
  color: rgba(0, 0, 0, 0.802);
  display: flex;
  div {
    padding: 10px 26px;
    cursor: pointer;
  }
  .activeItem {
    background: #fff;
    border-bottom: rgb(229, 49, 49) 2px solid;
  }
}
</style>
  